"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validPropFunction_1 = require("../JSchema/validPropFunction");
var fnumber_1 = require("../methods/fnumber");
var fmoney_1 = require("../methods/fmoney");
/**
 * sprawdza czy element lub podrzędne ma wyliczenia
 *
 * @export
 * @param {*} schema
 * @returns {boolean}
 */
function anyCalc(schema) {
    if (schema.anyCalc !== undefined) {
        return schema.anyCalc;
    }
    if (schema.calc || schema.summary || schema.aggregate) {
        Object.defineProperty(schema, 'anyCalc', {
            value: true
        });
        return true;
    }
    else if (schema.properties) {
        for (var key in schema.properties) {
            if (schema.properties.hasOwnProperty(key)) {
                var isCalc = anyCalc(schema.properties[key]);
                if (isCalc) {
                    Object.defineProperty(schema, 'anyCalc', {
                        value: true
                    });
                    return true;
                }
            }
        }
    }
    else if (schema.items) {
        return anyCalc(schema.items);
    }
    Object.defineProperty(schema, 'anyCalc', {
        value: false
    });
    return false;
}
exports.anyCalc = anyCalc;
/**
 * sprawdza czy element lub nadrzędny jest wyłączony
 *
 * @export
 * @param {IWrappedProperty} obj
 * @returns {boolean}
 */
function anyDisabled(obj) {
    return obj.$schema.disabled || (obj.$parent && anyDisabled(obj.$parent)) || false;
}
exports.anyDisabled = anyDisabled;
/**
 * hurtowe obudowanie dynamicznych pól schematu
 *
 * @export
 * @param {*} $schema schemat wyliczony
 * @param {IInternal} internal zmienne wewnętrzne obiektu
 * @param {string} type jeśłi pole schematu nie jest tego typu to znaczy że jest wyliczeniowe
 * @param {string[]} props jakie własciwości schematu obudować
 */
function wrapSchemaProps($schema, internal, type, props) {
    // tslint:disable-next-line: prefer-for-of
    for (var i = 0; i < props.length; i++) {
        var field = props[i];
        if (internal.schema[field] !== undefined) {
            if (typeof internal.schema[field] !== type) {
                wrapSchemaProp($schema, field, internal);
            }
            else {
                $schema[field] = internal.schema[field];
            }
        }
    }
}
exports.wrapSchemaProps = wrapSchemaProps;
/**
 * obudowanie pojedyńczej własciwości schematu
 *
 * @export
 * @param {*} $schema schemat decelowy
 * @param {string} field nazwa pola
 * @param {IInternal} internal zmienne wewnętrzne obiektu
 * @param {*} [func] callback wywoływany w przypadku zmiany wartości
 * @returns
 */
function wrapSchemaProp($schema, field, internal, func) {
    var schema = internal.schema;
    internal.needsCalcArgs = true;
    var v = schema[field];
    delete $schema[field];
    // if (self.isSimpleField(v)) {
    if (false) {
        // console.log(field + ' simplefield:', v);
        Object.defineProperty($schema, field, {
            enumerable: true,
            get: function () {
                return this.vm.$options.$ext.$model[v];
            }
        });
    }
    else {
        // console.log(`create valid function`, field, v, internal.parent);
        internal.useComputedModel = true;
        if (schema.cache === undefined) {
            schema.cache = {};
        }
        var ff_1 = schema.cache["schema_" + field];
        if (ff_1 === undefined) {
            ff_1 = validPropFunction_1.default(v);
            // console.log('calc func', ff.toString());
            schema.cache["schema_" + field] = ff_1;
        }
        internal.computed["schema_" + field] = {
            get: function () {
                // console.log('calc 2', field);
                return ff_1.apply(internal.parent, internal.calcargs);
            }
        };
        if (func) {
            // func(ff.apply(internal.parent, internal.calcargs));
            // internal.watch[`schema_${field}`] = func;
            internal.watch['schema_' + field] = {
                handler: func,
                immediate: true
            };
        }
        // delete $schema[field];
        Object.defineProperty($schema, field, {
            enumerable: true,
            get: function () {
                try {
                    return internal.vm["schema_" + field];
                }
                catch (err) {
                    if (process.env.NODE_ENV === 'development') {
                        console.error("[DEBUG] ERR get value: schama_" + field, err);
                        // tslint:disable-next-line: no-debugger
                        debugger;
                    }
                    return undefined;
                }
            }
        });
    }
}
exports.wrapSchemaProp = wrapSchemaProp;
/**
 * hurtowe obudowanie dynamicznych pól schematu dotyczących ostrzeżeń
 *
 * @export
 * @param {*} $schema schemat wyliczony
 * @param {IInternal} internal zmienne wewnętrzne obiektu
 * @param {string} type jeśłi pole schematu nie jest tego typu to znaczy że jest wyliczeniowe
 * @param {string[]} props jakie własciwości schematu obudować
 */
function wrapWarningProps($schema, internal, type, props) {
    var wr = internal.schema.warnings || {};
    // tslint:disable-next-line: prefer-for-of
    for (var i = 0; i < props.length; i++) {
        var field = props[i];
        if (wr[field] !== undefined) {
            if (typeof wr[field] !== type) {
                wrapWarningProp($schema, field, internal);
            }
            else {
                $schema.warnings[field] = wr[field];
            }
        }
    }
}
exports.wrapWarningProps = wrapWarningProps;
/**
 * obudowanie pojedyńczej własciwości schematu dotyczącego ostrzeżeń
 *
 * @export
 * @param {*} $schema schemat decelowy
 * @param {string} field nazwa pola
 * @param {IInternal} internal zmienne wewnętrzne obiektu
 * @param {*} [func] callback wywoływany w przypadku zmiany wartości
 * @returns
 */
function wrapWarningProp($schema, field, internal, func) {
    var schema = internal.schema;
    internal.needsCalcArgs = true;
    var v = schema.warnings[field];
    delete $schema.warnings[field];
    internal.useComputedModel = true;
    if (schema.cache === undefined) {
        schema.cache = {};
    }
    var ff = schema.cache["schema_warnings_" + field];
    if (ff === undefined) {
        ff = validPropFunction_1.default(v);
        schema.cache["schema_warnings_" + field] = ff;
    }
    internal.computed["schema_warnings_" + field] = {
        get: function () {
            return ff.apply(internal.parent, internal.calcargs);
        }
    };
    if (func) {
        internal.watch['schema_warnings_' + field] = {
            handler: func,
            immediate: true
        };
    }
    Object.defineProperty($schema.warnings, field, {
        enumerable: true,
        get: function () {
            try {
                return internal.vm["schema_warnings_" + field];
            }
            catch (err) {
                if (process.env.NODE_ENV === 'development') {
                    console.error("[DEBUG] cannot get schema_warnings_" + field, err);
                    // tslint:disable-next-line: no-debugger
                    debugger;
                }
                return undefined;
            }
        }
    });
}
exports.wrapWarningProp = wrapWarningProp;
var msgRegex = {
    minimum: /\{\{minimum\}\}/g,
    maximum: /\{\{maximum\}\}/g,
    exclusiveMaximum: /\{\{exclusiveMaximum\}\}/g,
    exclusiveMinimum: /\{\{exclusiveMinimum\}\}/g,
    multipleOf: /\{\{multipleOf\}\}/g,
    maxLength: /\{\{maxLength\}\}/g,
    minLength: /\{\{minLength\}\}/g,
    maxItems: /\{\{maxItems\}\}/g,
    minItems: /\{\{minItems\}\}/g,
    pattern: /\{\{pattern\}\}/g,
    format: /\{\{format\}\}/g,
    enum: /\{\{enum\}\}/g,
    title: /\{\{title\}\}/g,
    value: /\{\{value\}\}/g
};
var mustacheRegex = /{{([a-z.\[\]\s\?\"\'\:\(\)\+]*)}}/gim;
/**
 * pobranie komunikatu ostrzeżenia
 *
 * @export
 * @param {IInternal} internal dane wewnętrzne obiektu
 * @param {string} rule typ błedu
 * @param {*} value wartośc pola
 * @param {*} [$schema=null] schemat z wyliczonymi wartościami
 * @returns {string} komunikat ostrzeżenia
 */
function getWarningMessage(internal, rule, value, $schema) {
    if ($schema === void 0) { $schema = null; }
    $schema = $schema || internal.schema;
    var msg = internal.schema.warnings && internal.schema.warnings.warningMessages
        ? internal.schema.warnings.warningMessages[rule]
        : undefined;
    if (msg === undefined) {
        if (rule === 'type') {
            msg = internal.options.warningMessages[internal.schema.type];
        }
        if (msg === undefined) {
            msg = internal.options.warningMessages[rule] || rule;
        }
        // jeśli na starcie było zdefiniowane jako numer to od razu podmień
        if (typeof internal.schema.warnings[rule] === 'number') {
            msg = msg.replace(msgRegex[rule] || 'rrr', function () {
                return internal.schema.warnings[rule] === undefined
                    ? ''
                    : fnumber_1.default(internal.schema.warnings[rule]);
            });
        }
    }
    // zamiana {{maxLength}} na prawdziwą wartość
    return msg.replace(mustacheRegex, function (match, matchrule) {
        switch (matchrule) {
            case 'key':
                return internal.schema.$key || '';
            case 'title':
                return $schema.title || internal.schema.$key || '';
            case 'format':
                return internal.schema.format || '';
            case 'value':
                return value;
            case 'minimum':
            case 'maximum':
            case 'exclusiveMinimum':
            case 'exclusiveMaximum':
                var svalue = $schema.warnings[matchrule];
                if (svalue !== undefined) {
                    if (typeof svalue === 'number') {
                        if (internal.schema.type === 'money') {
                            return fmoney_1.default(svalue);
                        }
                        else {
                            return fnumber_1.default(svalue);
                        }
                    }
                    if (internal.schema.type === 'string' && internal.schema.format === 'date') {
                        if (svalue.length >= 10) {
                            return svalue.substr(8, 2) + "." + svalue.substr(5, 2) + "." + svalue.substr(0, 4);
                        }
                        else {
                            return svalue;
                        }
                    }
                    return svalue;
                }
                return '';
            default:
                return $schema.warnings[matchrule] || '';
        }
    });
}
exports.getWarningMessage = getWarningMessage;
/**
 * pobranie komunikatu błedu
 *
 * @export
 * @param {IInternal} internal dane wewnętrzne obiektu
 * @param {string} rule typ błedu
 * @param {*} value wartośc pola
 * @param {*} [$schema=null] schemat z wyliczonymi wartościami
 * @returns {string} komunikat błedu
 */
function getRuleMessage(internal, rule, value, $schema) {
    if ($schema === void 0) { $schema = null; }
    $schema = $schema || internal.schema;
    var msg = internal.schema.validationMessages ? internal.schema.validationMessages[rule] : undefined;
    if (msg === undefined) {
        if (rule === 'type') {
            msg = internal.options.validationMessages[internal.schema.type];
        }
        if (msg === undefined) {
            msg = internal.options.validationMessages[rule] || rule;
        }
        // jeśli na starcie było zdefiniowane jako numer to od razu podmień
        if (typeof internal.schema[rule] === 'number') {
            msg = msg.replace(msgRegex[rule] || 'rrr', function () {
                return internal.schema[rule] === undefined ? '' : fnumber_1.default(internal.schema[rule]);
            });
        }
    }
    // zamiana {{maxLength}} na prawdziwą wartość
    return msg.replace(mustacheRegex, function (match, matchrule) {
        switch (matchrule) {
            case 'key':
                return internal.schema.$key || '';
            case 'title':
                return $schema.title || internal.schema.$key || '';
            case 'format':
                return internal.schema.format || '';
            case 'value':
                return value;
            case 'minimum':
            case 'maximum':
            case 'exclusiveMinimum':
            case 'exclusiveMaximum':
                var svalue = $schema[matchrule];
                if (svalue !== undefined) {
                    if (typeof svalue === 'number') {
                        if (internal.schema.type === 'money') {
                            return fmoney_1.default(svalue);
                        }
                        else {
                            return fnumber_1.default(svalue);
                        }
                    }
                    if (internal.schema.type === 'string' && internal.schema.format === 'date') {
                        if (svalue.length >= 10) {
                            return svalue.substr(8, 2) + "." + svalue.substr(5, 2) + "." + svalue.substr(0, 4);
                        }
                        else {
                            return svalue;
                        }
                    }
                    return svalue;
                }
                return '';
            default:
                return $schema[matchrule] || '';
        }
    });
}
exports.getRuleMessage = getRuleMessage;
/**
 * inicjalizacja wewnętrznego obiektu Vue
 *
 * @export
 * @param {IWrappedProperty} prop do którego obiektu jest tworzony
 * @param {IInternal} internal dane wewnętrzne obiektu
 * @returns {*}
 */
function initVue(prop, internal) {
    if (internal.needsCalcArgs) {
        if (internal.options.external) {
            internal.calcargs[4] = internal.options.external;
            // console.log('set external', self.external);
        }
        else {
            internal.calcargs[4] = {};
        }
        internal.calcargs[5] = internal.options.schemaMethods;
        internal.calcargs[6] = prop;
        internal.calcargs[0] = prop.$root.$model;
        var dest = prop.$parent;
        if (dest && dest.$parent) {
            internal.calcargs[1] = dest.$parent.$model;
            if (dest.$parent.$parent) {
                internal.calcargs[2] = dest.$parent.$parent.$model;
                if (dest.$parent.$parent.$parent) {
                    internal.calcargs[3] = dest.$parent.$parent.$parent.$model;
                }
                else {
                    internal.calcargs[3] = {};
                }
            }
            else {
                internal.calcargs[2] = internal.calcargs[3] = {};
            }
        }
        else {
            internal.calcargs[1] = internal.calcargs[2] = internal.calcargs[3] = {};
        }
    }
    if (internal.useComputedModel || internal.needsCalcArgs) {
        internal.useComputedModel = true;
        internal.computed.model = {
            get: function () { return prop.getValue(); },
            set: function (newValue) { return prop.setValue(newValue); }
        };
        internal.vm = new internal.options.Vue({
            computed: internal.computed,
            watch: internal.watch,
            beforeCreate: function () {
                // taki trick, bo computed i watch są wykonywane przed `created`
                internal.vm = this;
            }
        });
    }
    else {
        // internal.vm = internal.options.Vue.observable(internal.reactiveData);
    }
}
exports.initVue = initVue;
//# sourceMappingURL=functions.js.map